import { useEffect, useState } from "react";
import { IError, RootGizmo } from "flowy-3-core";
import { Button, Modal, Typography } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";

type WarningModalProps = {
  errors: IError[];
  rootGizmo: RootGizmo;
};

const { Text } = Typography;

const WarningModal = ({ errors, rootGizmo }: WarningModalProps) => {
  const [visible, setVisible] = useState(true);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (errors.length > 0) {
      setVisible(true);

      const error = errors[0];
      if (error.data?.message) {
        setMessage(error.data.message);
      }
    }
  }, [errors]);

  const handleOkClick = async () => {
    setLoading(true);
    const callbacks = rootGizmo.getCallbacks();
    const rootGizmoData = rootGizmo.getData();
    // const events = rootGizmo.getEvents();

    if (rootGizmoData) {
      await callbacks.submitRootGizmoDataCB({
        rootGizmoData,
        onSubmitFinish: () => {
          // const afterSubmitEvent: IGizmoEvent = {
          //   type: 'root-gizmo.operation',
          //   src: {
          //     type: 'root-gizmo',
          //     rootGizmoFid: rootGizmo.getConfig().fid,
          //   },
          //   dest: {
          //     type: 'gizmo',
          //     gizmoFid: event.src.gizmoFid,
          //     gizmoUid: event.src.gizmoUid,
          //   },
          //   data: {
          //     rootGizmoOperation: {
          //       type: 'form.lifecycle.after-submit',
          //     },
          //   },
          // };
          // events.next(afterSubmitEvent);
        },
      });
    }
  };

  const handleCancelClick = () => {
    setVisible(false);
  };

  return (
    <div>
      {errors.length > 0 && (
        <Modal
          open={visible}
          title={
            <div>
              <CloseCircleFilled style={{ color: "##ffde21" }} /> Advertencia
            </div>
          }
          footer={[
            <Button
              key="button-cancel"
              onClick={handleCancelClick}
              loading={loading}
            >
              Cancelar
            </Button>,
            <Button
              key="button-ok"
              style={{ backgroundColor: "#AB0A3D", color: "white" }}
              onClick={handleOkClick}
              loading={loading}
            >
              Aceptar
            </Button>,
          ]}
          style={{ top: 20 }}
        >
          {errors.length > 0 &&
            errors.map((error: IError) => (
              <span key={error.fid}>
                <Text>{message}</Text>
                <br />
              </span>
            ))}
        </Modal>
      )}
    </div>
  );
};

export default WarningModal;
